<template lang="pug">
  v-menu(
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  )
    template(v-slot:activator='{ on }')
      v-combobox(label="Estimated Job Installation Date" outline v-model="formattedDate" v-on='on' readonly :rules="[(v) => !!v || 'Installation Date is required']")
    v-date-picker(v-model="date" @input="menu = false" :min="todaysDate")
</template>

<script>
  import moment from 'moment'
  import {mapActions} from 'vuex'

  export default {
    name: 'DatePicker',
    data: () => ({
      menu: false,
      date: null,
    }),
    computed: {
      formattedDate() {
        return this.date ? moment(this.date).format('MM/DD/YYYY') : ''
      },
      todaysDate() {
        const newDate = new Date().toString()
        return moment(newDate).format('YYYY-MM-DD')
      }
    },
    watch: {
      date(value){
        //Here we change send the value from the datepicker to our store to save
        //the new date in state every time the value of date changes.
        
        this.setInstallationDate(value)
      }
    },
    methods: {
      ...mapActions(['setInstallationDate'])
    },
    mounted(){
      //We reset the value in store of installation date back to '' so the user
      //can re-pick their date whenver the component mounts.
     this.setInstallationDate('')
    }
  }
</script>

<style lang="scss" scoped>

</style>